import * as React from 'react';

const SvgOutreachSender = (props) => (
  <svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_967_3961)">
      <circle cx={21} cy={18} r={12} fill="#4397F7" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3877 22.9456C22.3877 23.3854 22.4652 23.8071 22.6071 24.1978C22.1966 24.2866 21.7704 24.3333 21.3334 24.3333C18.0197 24.3333 15.3334 21.647 15.3334 18.3333C15.3334 15.0196 18.0197 12.3333 21.3334 12.3333C24.6471 12.3333 27.3334 15.0196 27.3334 18.3333C27.3334 18.722 27.2964 19.102 27.2258 19.4701C26.858 19.3461 26.464 19.279 26.0544 19.279C24.0294 19.279 22.3877 20.9206 22.3877 22.9456ZM21.3334 20.1666C20.3663 20.1666 19.4589 20.4158 18.6703 20.8531C18.4288 20.987 18.1245 20.8998 17.9906 20.6583C17.8567 20.4168 17.9439 20.1125 18.1854 19.9786C19.1185 19.4611 20.1923 19.1666 21.3334 19.1666C21.5771 19.1666 21.8179 19.1801 22.055 19.2063C22.3295 19.2366 22.5274 19.4837 22.497 19.7582C22.4667 20.0327 22.2196 20.2306 21.9451 20.2002C21.7444 20.1781 21.5403 20.1666 21.3334 20.1666ZM21.3334 14.3333C22.4379 14.3333 23.3334 15.2287 23.3334 16.3333C23.3334 17.4379 22.4379 18.3333 21.3334 18.3333C20.2288 18.3333 19.3334 17.4379 19.3334 16.3333C19.3334 15.2287 20.2288 14.3333 21.3334 14.3333ZM28.6667 23C28.6667 21.8544 27.9443 20.8775 26.9302 20.5001C26.6406 20.3923 26.3272 20.3333 26 20.3333C24.5272 20.3333 23.3333 21.5272 23.3333 23C23.3333 23.3272 23.3923 23.6406 23.5001 23.9302C23.8775 24.9443 24.8544 25.6667 26 25.6667C27.4728 25.6667 28.6667 24.4728 28.6667 23ZM26.5 21.6667C26.5 21.3905 26.2761 21.1667 26 21.1667C25.7239 21.1667 25.5 21.3905 25.5 21.6667V22.5H24.6667C24.3905 22.5 24.1667 22.7239 24.1667 23C24.1667 23.2761 24.3905 23.5 24.6667 23.5H25.5V24.3333C25.5 24.6095 25.7239 24.8333 26 24.8333C26.2761 24.8333 26.5 24.6095 26.5 24.3333V23.5H27.3333C27.6095 23.5 27.8333 23.2761 27.8333 23C27.8333 22.7239 27.6095 22.5 27.3333 22.5H26.5V21.6667Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_967_3961"
        x={0}
        y={0}
        width={42}
        height={42}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_967_3961"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={4} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_967_3961"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_967_3961"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgOutreachSender;
